var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 35 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 15.35,
    y1: -7.01,
    x2: 17.33,
    y2: 91.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#16375b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#2a68a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#16375b"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 200 0 0 35 0 35 200 18 175 0 200"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M864.7,596a5.46,5.46,0,0,1-.73,2.86,4.93,4.93,0,0,1-2,1.91,6.64,6.64,0,0,1-3.07.67h-4.29a6.63,6.63,0,0,1-3.08-.67,4.89,4.89,0,0,1-2-1.91,5.88,5.88,0,0,1-.17-5.34,5.14,5.14,0,0,1,1.55-1.88,5.55,5.55,0,0,1,2.33-1v1.55a3.91,3.91,0,0,0-1.58.85,4.06,4.06,0,0,0-1,1.37,3.69,3.69,0,0,0-.37,1.62,3.59,3.59,0,0,0,1.2,2.82,4.61,4.61,0,0,0,3.2,1.08h4.29a4.57,4.57,0,0,0,3.18-1.08,3.56,3.56,0,0,0,1.21-2.82,4,4,0,0,0-.78-2.35,3.87,3.87,0,0,0-2.21-1.49v-1.55a5.61,5.61,0,0,1,2.33,1,5.36,5.36,0,0,1,1.55,1.89A5.46,5.46,0,0,1,864.7,596Z",
    transform: "translate(-839.5 -439)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M864.7,582.62a5.43,5.43,0,0,1-1.43,4.12,6,6,0,0,1-4.28,1.37h-10.1v-1.55h10.17a4.36,4.36,0,0,0,3.09-1,4.83,4.83,0,0,0,0-5.94,4.36,4.36,0,0,0-3.09-1H848.89v-1.55H859a6,6,0,0,1,4.28,1.37A5.46,5.46,0,0,1,864.7,582.62Z",
    transform: "translate(-839.5 -439)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M864.7,569.18a10.52,10.52,0,0,1-.21,2.15,7.94,7.94,0,0,1-1.73,3.52l-1.22-.94a7,7,0,0,0,1.29-2.16,7.41,7.41,0,0,0,.43-2.57,5.25,5.25,0,0,0-.8-3.12,2.6,2.6,0,0,0-2.24-1.1h0a2,2,0,0,0-1.5.54,3.48,3.48,0,0,0-.8,1.4,17.85,17.85,0,0,0-.46,1.88c-.12.63-.26,1.25-.41,1.88a7,7,0,0,1-.62,1.72,3.19,3.19,0,0,1-1.14,1.25,3.52,3.52,0,0,1-1.95.48h0a4.15,4.15,0,0,1-3.39-1.46,6.24,6.24,0,0,1-1.2-4.1,7.57,7.57,0,0,1,.41-2.44,9,9,0,0,1,1.23-2.36l1.21.91a8.28,8.28,0,0,0-1.05,2,5.45,5.45,0,0,0-.35,1.91,4.82,4.82,0,0,0,.8,3,2.68,2.68,0,0,0,2.27,1.05h0a1.83,1.83,0,0,0,1.48-.6,4,4,0,0,0,.76-1.55c.17-.63.33-1.31.47-2s.27-1.2.44-1.8a6.57,6.57,0,0,1,.67-1.6,3.33,3.33,0,0,1,1.17-1.16,3.82,3.82,0,0,1,1.9-.43h0a4,4,0,0,1,3.35,1.51A6.71,6.71,0,0,1,864.7,569.18Z",
    transform: "translate(-839.5 -439)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M850.34,562.47h-1.45v-11h1.45Zm14.2-4.75h-15v-1.55h15Z",
    transform: "translate(-839.5 -439)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M864.7,544.53a6.1,6.1,0,0,1-.68,3,4.46,4.46,0,0,1-2,1.87,6.92,6.92,0,0,1-3.12.65H854.5a6.86,6.86,0,0,1-3.12-.65,4.46,4.46,0,0,1-2-1.87,6.87,6.87,0,0,1,0-6,4.46,4.46,0,0,1,2-1.87,6.86,6.86,0,0,1,3.12-.65h4.43a6.92,6.92,0,0,1,3.12.65,4.46,4.46,0,0,1,2,1.87A6.1,6.1,0,0,1,864.7,544.53Zm-1.44,0a3.79,3.79,0,0,0-1.11-2.92,4.5,4.5,0,0,0-3.14-1h-4.59a4.47,4.47,0,0,0-3.13,1,4.4,4.4,0,0,0,0,5.84,4.47,4.47,0,0,0,3.13,1H859a4.5,4.5,0,0,0,3.14-1A3.79,3.79,0,0,0,863.26,544.53Z",
    transform: "translate(-839.5 -439)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M860.19,529.05l-11.3-5V522.4h15.65V524H851.1l.69-.16,10.58,4.71v1.1L852,534.31l-.9-.16h13.44v1.55H848.89v-1.63Z",
    transform: "translate(-839.5 -439)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M848.89,516.65h15.65v1.55H848.89Z",
    transform: "translate(-839.5 -439)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M848.89,503.59H850l13.17,7.73v-7.94h1.33v9.72H863.4l-13.17-7.78v7.59h-1.34Z",
    transform: "translate(-839.5 -439)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M864.54,502l-15.65-5.77v-1.87l15.65-5.77v1.72l-14,5,14,5Zm-3.8-2.66H859.3v-8.23h1.44Z",
    transform: "translate(-839.5 -439)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M864.54,484.91H863.1v-4.29a4.3,4.3,0,0,0-.79-2.94,2.64,2.64,0,0,0-2.06-.87h0a3,3,0,0,0-2.16.76,3.3,3.3,0,0,0-.81,2.51v4.83h-1.44v-4.83a3.36,3.36,0,0,0-.68-2.3,2.54,2.54,0,0,0-2-.77,2.51,2.51,0,0,0-2.07.84,3.94,3.94,0,0,0-.69,2.53v4.53h-1.45V480a4.65,4.65,0,0,1,1.16-3.45,4.2,4.2,0,0,1,3.08-1.12,3.64,3.64,0,0,1,2.13.68,3.17,3.17,0,0,1,1.26,2.17,3.34,3.34,0,0,1,1.28-2.26,4,4,0,0,1,2.45-.8h0a4.05,4.05,0,0,1,3.09,1.24,4.67,4.67,0,0,1,1.17,3.35Zm0,1.29H848.89v-1.55h15.65Z",
    transform: "translate(-839.5 -439)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M864.54,472H848.89v-1.55h15.65Zm0-1.1H863.1v-8.95h1.44Z",
    transform: "translate(-839.5 -439)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M850.34,458.28h-1.45v-9h1.45Zm14.2,1.07H848.89V457.8h15.65Zm-7-1.07h-1.44v-7.8h1.44Zm7,0H863.1v-9h1.44Z",
    transform: "translate(-839.5 -439)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomize);
export default __webpack_public_path__ + "static/media/customize.41492f3ebd5ede230598abf8e108d90e.svg";
export { ForwardRef as ReactComponent };